import { Component, forwardRef, Input, Output, StaticProvider, EventEmitter } from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { ControlBase } from "../control-base";

const TextValueAccessor = <StaticProvider>{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => TextControlComponent),
    multi: true
};

@Component({
    selector: "m-text-control",
    template: '<input type="text" [disabled]="disabled" [readonly]="readonly" pInputText [(ngModel)]="text" (blur)="_onBlur()" (click)="click()" />',
    providers: [TextValueAccessor]
})
export class TextControlComponent extends ControlBase<string> {
    private _text: string;

    @Input() readonly: boolean = false;

    @Output() readonly onClick = new EventEmitter<null>();

    get text() {
        return this._text;
    }

    set text(text: string) {
        this._text = text;
        this.onChange(this._text);
    }

    writeValue(obj: string): void {
        this._text = obj;
    }

    click(){
        this.onClick.emit(null);
    }
}
